module.exports = __webpack_public_path__ + "assets/img/binding-1-sm.a9e321cb.jpg";